import React, { useEffect } from "react";

const Seo = ({ title, description, image }) => {
  useEffect(() => {
    if (title) document.title = title;
    const set = (name, content, prop = false) => {
      if (!content) return;
      const attr = prop ? "property" : "name";
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    set("description", description);
    set("og:title", title, true);
    set("og:description", description, true);
    if (image) set("og:image", image, true);
    set("og:type", "website", true);
  }, [title, description, image]);
  return null;
};

export default Seo;
